import type { LabelValue } from '@/types/common';

export enum ScheduleInterviewType {
	AGENCY = 'AGENCY',
	CLIENT = 'CLIENT',
}

export interface ScheduleInterviewPayload {
	date: Date;
	start: string;
	end: string;
	contactId: string;
	interviewType: ScheduleInterviewType;
	comment?: string;
}

export interface RescheduleInterviewPayload {
	date: Date;
	start: string;
	end: string;
	contactId: string;
	comment?: string;
}

export interface ExistingInterview {
	id: string;
	date: string | Date;
	start: string;
	end?: string;
	comment?: string;
	contactId?: string;
	contactName?: string;
}

export interface ScheduleInterviewResponse {
	id: string;
	workerId: string;
	besoinId: string;
	contactId: string;
	date: Date;
	start: string;
	end: string;
	comment: string;
	createdBy: string;
	interviewType: ScheduleInterviewType;
}

export interface ScheduleInterviewSuccessPayload {
	interview: ScheduleInterviewResponse;
	contactLabel?: string;
}

export interface ProfileScheduleInterviewModalProps {
	open: boolean;
	mode: ScheduleInterviewType;
	workerId: string;
	companyNeedId: string;
	workerFirstname?: string;
	workerLastname?: string;
	companyId?: string;
	existingInterview?: ExistingInterview;
	preloadedCompanyContacts?: LabelValue<string>[];
	onSuccess?: (
		payload?: ScheduleInterviewSuccessPayload
	) => void | Promise<void>;
	onCancel?: () => void;
}

export interface CollaboratorOption {
	label: string;
	value: string;
}
